import Dialog from '@/components/Dialog';
import styled from '@emotion/styled';
import { Download as DownloadIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useMediaQuery } from '@mui/system';
import fileDownload from 'js-file-download';
import { FormattedMessage } from 'react-intl';

const DownloadButton = styled(Dialog.Actions.Button)({
  marginLeft: '12px !important',
  flexShrink: 0,
});

const DownloadIconButton = styled(IconButton)(({ theme }) => ({
  marginLeft: '12px !important',
  marginRight: -6,
  color: `${theme.palette.getContrastText(grey[300])} !important`,
  backgroundColor: grey[300],
  ':hover': {
    backgroundColor: grey[400],
  },
}));

type ImageDownloadProps = {
  imageFilename: string;
  imageBlob: Blob;
};

const ImageDownload = ({ imageFilename, imageBlob }: ImageDownloadProps) => {
  const useIconButton = useMediaQuery('(max-width: 640px)');

  const handleDownloadFile = (): void => {
    fileDownload(imageBlob, imageFilename);
  };

  if (useIconButton) {
    return (
      <Tooltip
        title={
          <FormattedMessage id="portfolio.challenge.files.uploaded_image.preview_dialog.download_button" />
        }
      >
        <DownloadIconButton onClick={handleDownloadFile}>
          <DownloadIcon />
        </DownloadIconButton>
      </Tooltip>
    );
  }

  return (
    <DownloadButton startIcon={<DownloadIcon />} onClick={handleDownloadFile}>
      <FormattedMessage id="portfolio.challenge.files.uploaded_image.preview_dialog.download_button" />
    </DownloadButton>
  );
};

export default ImageDownload;
